<template>
  <div>
    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between >
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <v-icon color="primary" large>email</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                Emails
              </h1>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row wrap mb-4>
      <v-flex>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-content class="v-expansion-panel-emails">

            <template v-slot:header>
              <v-layout row class="subheading" >
                <v-flex class="white--text">
                  <v-icon color="white" class="pr-3">list</v-icon>
                  All Emails
                </v-flex>
              </v-layout>
            </template>

            <v-card>
              <v-layout justify-end row wrap>
                <v-flex shrink class="mr-3" xs6 md4 lg3>
                  <v-text-field v-model="pagination.search"
                    append-icon="search"
                    label="Search"
                    single-line
                    inline-flex
                    hint="Use & and | to join search terms"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="headers"
                :items="emails"
                :total-items="totalEmails"
                :loading="loading"
                :pagination.sync="pagination"
                :must-sort="true"
                no-data-text="Loading emails..."
                >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left link">
                    {{props.item.attributes.created_at |formatDateTime}}
                    <br>
                    {{props.item.attributes.created_at |formatDateAgo}}
                  </td>
                  <td class="text-xs-left link">
                    <router-link
                      :to="{ path: props.item.links.project_show_uri }">
                      {{props.item.attributes.subject}}
                    </router-link>
                  </td>
                  <td class="text-xs-left link">
                    {{props.item.attributes.from}}
                  </td>
                  <td class="text-xs-left link">
                    <v-chip disabled small outline  v-for="ticket in ticketsForEmail(props.item.id)" :key="ticket.id">
                      <a :href="ticketUrl(ticket)" target="ticket">
                        #{{ticketNumber(ticket)}}
                      </a>
                    </v-chip>
                  </td>
                </template>
                <v-alert slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                  >
                  Your search for "{{ pagination.search }}" found no results.
                </v-alert>
              </v-data-table>
              <div class="pb-4">
                <!-- Last line to provide padding for the favbuttons -->
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { debounce } from 'debounce'
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'

  import emailService from '@/services/email'
  import ticketService from '@/services/ticket'

  export default {
    name: 'email-index',

    components: {
    },

    props: ['projectId'],

    data () {
      return {
        auth: authentication,
        totalEmails: 0,
        emails: [],
        tickets: {},
        loading: true,
        panel: null,
        headers: [
          { text: 'Received', value: 'created_at', align: 'left' },
          { text: 'Subject', value: 'subject', align: 'left' },
          { text: 'From', value: 'from', align: 'left' },
          { text: 'Ticket', value: 'from', align: 'left', sortable: false }
        ],
        pagination: {
          rowsPerPage: parseInt(authentication.preferences().page_size) || 5,
          sortBy: (authentication.preferences().email_sort_by || 'created_at'),
          descending: !(authentication.preferences().email_sort_order === 'asc'), // This is to deal with the preference being unset
          search: ''
        }
      }
    },

    watch: {
      pagination: {
        handler (val) {
          if (!this.loading) {
            this.reloadEmails()
          }
        },
        deep: true
      }
    },

    mounted () {
      this.loadEmails()

      EventBus.$on('email-deleted', (payload) => {
        if (payload) {
          this.emails = this.emails.filter(w => parseInt(w.id) !== parseInt(payload.id))
        }
      })

      this.panel = 0
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      }
    },

    methods: {
      loadEmails () {
        this.loading = true
        emailService.projectIndex(
          async (data, total) => {
            this.emails = data
            this.totalEmails = total
            let ticketsPromises = []
            for (const email of data) {
              ticketsPromises.push(this.loadTickets(email.id))
            }
            await Promise.all(ticketsPromises)
            this.loading = false
          },
          (err) => {
            console.log(err)
          },
          this.projectId,
          this.pagination
        )
      },

      reloadEmails: debounce(function () {
        this.loadEmails()
      }, 500),

      loadTickets (emailId) {
        return ticketService.emailIndex(
          (data) => {
            this.tickets[emailId] = data
          },
          (err) => {
            console.log(err)
          },
          this.projectId,
          emailId
        )
      },

      ticketsForEmail (emailId) {
        return this.tickets[emailId] || []
      },

      ticketUrl (ticket) {
        return ticket.links.project_show_uri
      },

      ticketNumber (ticket) {
        return ticket.links.project_show_uri.split('/').pop()
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* normal/closed are darker blue*/
  .v-expansion-panel-emails {
    background-color: #0155a8 !important;
  }

  @media screen and (min-width: 600px) {
    .sticky-element{
      position: sticky;
      position: -webkit-sticky;
      top: 65px;
      z-index: 5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/email/index.vue